module.exports = __webpack_public_path__ + "img/netProfitOrange.9d0dc6e4.png";